export const languageSet: any = {
    hu: {
        impressum_link: 'https://www.efs-zrt.hu/kapcsolat/#impresszum',
        impressum_text: 'Impresszum',

        support_text: 'Hozzáférhetőség',
        support_ln1: 'Hétfő-Péntek: 8:00 – 17:00',
        support_ln2: '',

        contact_text_ln1: 'Kérdésed, problémád van',
        contact_text_ln2: 'Fordulj mindig bizalommal IT támogatáshoz',
        contact_phone: '+36 70 427 8126',
        contact_mail: 'support@efs-zrt.hu',
        contact_vcf: '',

        website: 'www.efs-zrt.hu',

        news: 'EFShírek',
        read_more: 'Olvass tovább',
        list_news: 'Összes hír megjelenítése',
        back: 'Vissza',
        unread_news: 'olvasatlan',
        more_apps: 'További alkalmazások megjelenítése',
        more_apps_hide: 'A fennmaradó alkalmazások elrejtése',

        opener: '%name, üdvözlünk az EFS-WORLD-ben!',

        fastclient_text: 'Távoli karbantartási szoftver',
        fastclient_link: 'https://get.teamviewer.com/EFS_IT-Support',

        faq_no_questions: 'Nincsenek kérdések a kiválasztott alkalmazáshoz!',
        faq: 'Gyakran Ismételt Kérdések (GYIK)',
        faq_header: 'Válasszon kategóriát',

        logout: 'Kijelentkezés',
        logout_question: 'Valóban ki szeretne jelentkezni?',
        logout_yes: 'Kijelentkezés',
        logout_no: 'Mégsem',

        updated: 'Aktualizálva',
        created: 'Létrehozva',
        updatedAt: 'Aktualizálva',
        createdAt: 'Létrehozva',
        news_read_missing_permissions: 'Ön nem jogosult ezt a hírt olvasni!',
        generic_loading_error: 'Az adatokat nem lehetett betölteni. Kérjük, próbálja meg később újra!',

        contact_support: 'EFS-IT-Support érintkezés',
        contact_hr: 'Personal érintkezés',
        hr: 'Personal',
        contact_contract: 'Antrags érintkezés',
        contract: 'Antrags',
        change_password: 'Jelszó módosítása',
        autoresponder: 'Hiányzó üzenetek',
        two_factor_authentication: 'Kétfaktoros hitelesítés',
    },

    de: {
        impressum_link: 'https://www.efs-ag.de/kontakt/#impressum',
        impressum_text: 'Impressum',

        support_text: 'Erreichbarkeit der EFS-Hauptverwaltung Mainz',
        support_ln1: 'Mo-Do 9.00 - 17.00 Uhr',
        support_ln2: 'Fr 9.00 - 15.30 Uhr',

        contact_text_ln1: 'Noch Fragen oder Probleme',
        contact_text_ln2: 'EFS-IT-Support',
        contact_phone: '+49 6131 58388-55',
        contact_mail: 'support@efs-ag.com',
        contact_vcf: 'Telefonbuchkontakt',

        website: 'www.efs-ag.de',

        news: 'EFSnews',
        read_more: 'Mehr lesen',
        list_news: 'Alle News anzeigen',
        back: 'Zurück',
        unread_news: 'ungelesene',
        more_apps: 'Restliche Apps einblenden',
        more_apps_hide: 'Restliche Apps ausblenden',

        opener: 'HERZLICH WILLKOMMEN IN DEINER EFS-IT-WORLD, %name!',

        fastclient_text: 'Fernwartungssoftware',
        fastclient_link: 'https://get.teamviewer.com/EFS_IT-Support',

        faq: 'FAQ',
        faq_no_questions: 'Für die ausgewählte App gibt es keine FAQs!',
        faq_header: 'WÄHLE EIN THEMENGEBIET AUS',

        logout: 'Abmelden',
        logout_question: 'Möchtest du dich wirklich aus deiner EFS-IT-World abmelden?',
        logout_yes: 'Abmelden',
        logout_no: 'Abbrechen',

        updated: 'Aktualisiert',
        created: 'Erstellt',
        updatedAt: 'Aktualisiert am',
        createdAt: 'Erstellt am',
        news_read_missing_permissions: 'Du hast keine Berechtigung, diese News zu lesen!',
        generic_loading_error: 'Die Daten konnten nicht geladen werden. Bitte versuche es später erneut!',

        contact_support: 'Anliegen beim EFS-IT-Support erstellen',
        contact_hr: 'Personalabteilung kontaktieren',
        hr: 'Personalabteilung',
        contact_contract: 'Antragsabteilung kontaktieren',
        contract: 'Antragsabteilung',
        change_password: 'Passwort ändern',
        autoresponder: 'Abwesenheitsagent',
        two_factor_authentication: 'Zwei-Faktor-Authentifizierung',
    },

    at: {
        impressum_link: 'https://www.efs-ag.at/kontakt/#impressum',
        impressum_text: 'Impressum',

        support_text: 'Erreichbarkeit der EFS-Hauptverwaltung Mainz',
        support_ln1: 'Mo-Do 9.00 - 17.00 Uhr',
        support_ln2: 'Fr 9.00 - 15.30 Uhr',

        contact_text_ln1: 'Noch Fragen oder Probleme',
        contact_text_ln2: 'EFS-IT-Support',
        contact_phone: '+49 6131 58388-55',
        contact_mail: 'support@efs-ag.com',
        contact_vcf: 'Telefonbuchkontakt',

        website: 'www.efs-ag.at',

        news: 'EFSnews',
        read_more: 'Mehr lesen',
        list_news: 'Alle News anzeigen',
        back: 'Zurück',
        unread_news: 'ungelesene',
        more_apps: 'Restliche Apps einblenden',
        more_apps_hide: 'Restliche Apps ausblenden',

        opener: 'HERZLICH WILLKOMMEN IN DEINER EFS-IT-WORLD, %name!',

        fastclient_text: 'Fernwartungssoftware',
        fastclient_link: 'https://get.teamviewer.com/EFS_IT-Support',

        faq: 'FAQ',
        faq_no_questions: 'Für die ausgewählte App gibt es keine FAQs!',
        faq_header: 'WÄHLE EIN THEMENGEBIET AUS',

        logout: 'Abmelden',
        logout_question: 'Möchtest du dich wirklich aus deiner EFS-IT-World abmelden?',
        logout_yes: 'Abmelden',
        logout_no: 'Abbrechen',

        updated: 'Aktualisiert',
        created: 'Erstellt',
        updatedAt: 'Aktualisiert am',
        createdAt: 'Erstellt am',
        news_read_missing_permissions: 'Du hast keine Berechtigung, diese News zu lesen!',
        generic_loading_error: 'Die Daten konnten nicht geladen werden. Bitte versuche es später erneut!',

        contact_support: 'Anliegen beim EFS-IT-Support erstellen',
        contact_hr: 'Personalabteilung kontaktieren',
        hr: 'Personalabteilung',
        contact_contract: 'Antragsabteilung kontaktieren',
        change_password: 'Passwort ändern',
        autoresponder: 'Abwesenheitsagent',
        two_factor_authentication: 'Zwei-Faktor-Authentifizierung',
    }
};
